import { render, staticRenderFns } from "./productShow.vue?vue&type=template&id=6a3d418f&scoped=true"
import script from "./productShow.vue?vue&type=script&lang=js"
export * from "./productShow.vue?vue&type=script&lang=js"
import style0 from "./productShow.vue?vue&type=style&index=0&id=6a3d418f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d418f",
  null
  
)

export default component.exports